export default {
  Register: {
    Register: 'Đăng ký',
    RegisterSubtitle:
      'Nhập SĐT, họ tên và mật khẩu để đăng ký <span>tài khoản</span>',
    TypePhoneNumber: 'Nhập số điện thoại (bắt buộc)',
    TypeEmail: 'Nhập địa chỉ email',
    TypeFullName: 'Nhập họ và tên (bắt buộc)',
    TypePassword: 'Nhập mật khẩu (bắt buộc)',
    TypeConfirmPassword: 'Xác nhận mật khẩu (bắt buộc)',
    SuccessSubtitle: 'Chúc mừng bạn đăng ký tài khoản thành công.',
    HasAccount: 'Bạn đã có tài khoản?',
    GetPasswordAgain: 'Lấy lại mật khẩu',
    Or: 'hoặc',
  },

  Login: {
    Login: 'Đăng nhập',
    TypeUserName: 'Nhập số điện thoại',
    TypePassword: 'Nhập mật khẩu',
    ForgotPassword: 'Quên mật khẩu?',
    SuggestRegister: 'Bạn chưa có tài khoản?',
    BackHome: 'Quay lại trang chủ',
  },

  ForgotPassword: {
    Title: 'Lấy lại mật khẩu',
    ChangePassword: 'Tạo mật khẩu mới',
    BackLoginPage: 'Quay lại đăng nhập',
    UsePhoneNumber: 'Sử dụng số điện thoại',
    UseEmail: 'Sử dụng email',
    SubtitleEnterPhone:
      'Vui lòng nhập số điện thoại đã đăng ký để được hướng dẫn lấy lại mật khẩu',
    SubtitleEnterEmail:
      'Vui lòng nhập email đã đăng ký để nhận mã xác thực lấy lại mật khẩu',
    SubtitleEnterOtpPhoneMode:
      'Để nhận mã OTP, vui lòng dùng SĐT <br><b>{phoneNumber}</b> soạn tin nhắn với cú pháp: <br><b>{syntax}</b> gửi <b>{callCenter}</b><br>(Cước phí tin nhắn theo quy định nhà mạng là <br/> {fee} đồng/tin nhắn)',
    SubtitleEnterOtpPhoneModeWithFirebaseAuthenticate:
      'Mã xác thực đã được gửi đến SĐT <b>{phoneNumber}</b>. Vui lòng kiểm tra tin nhắn và nhập chính xác mã vào ô dưới.',
    SubtitleEnterOtpEmailMode:
      'Mã xác thực đã được gửi đến email <b>{email}</b>. Vui lòng kiểm tra email và nhập chính xác mã vào ô dưới.',
    SubtitleEnterEmailOtp:
      'Để nhận mã OTP, vui lòng kiểm tra mã trong email <b>{email}</b> của bạn',
    GetPasswordAgainBtn: 'Lấy lại mật khẩu',
    ContinueBtn: 'Tiếp tục',
    ChangePasswordBtn: 'Đổi mật khẩu',
    PhoneNumberPlaceholder: 'Số điện thoại',
    EmailPlaceholder: 'Email',
    VerifyOTPPlaceholder: 'Mã xác thực',
    NewPasswordPlaceholder: 'Mật khẩu mới',
    ConfirmNewPasswordPlaceholder: 'Xác nhận mật khẩu mới',
    ChangePasswordSuccess: 'Tạo mật khẩu mới thành công',
  },

  ValidateMessage: {
    PhoneNumber: 'Số điện thoại',
    Email: 'Email',
    FullName: 'Họ và tên',
    Password: 'Mật khẩu',
    OTP: 'Mã xác thực',
    ConfirmPassword: 'Xác nhận mật khẩu',
    ConfirmPasswordNotMatch: 'Xác nhận mật khẩu phải trùng khớp với mật khẩu',
    ExistedPhoneNumber: 'Số điện thoại đã tồn tại',
    ExistedEmail: 'Email đã tồn tại',
    InvalidPhoneNumber: 'Số điện thoại không đúng định dạng',
    InvalidEmail: 'Email không đúng định dạng',
    ValidPasswordLength: 'Mật khẩu phải có ít nhất 8 ký tự',
    InvalidPasswordLength:
      '<div style="display: flex"><div class="icon20-v2 X" style="margin-right: 8px"></div> Mật khẩu phải có ít nhất 8 ký tự</div>',
    InvalidUserName: 'Tên đăng nhập không tồn tại',
    InvalidPassword: 'Mật khẩu đăng nhập không chính xác',
    InvalidAccount: 'Số điện thoại đăng nhập hoặc mật khẩu không chính xác',
    InvalidForgotPhoneNumber:
      'Số điện thoại không hợp lệ. Vui lòng kiểm tra lại!',
    InvalidForgotEmail: 'Email không hợp lệ. Vui lòng kiểm tra lại!',
    InvalidOTP: 'Mã xác thực không hợp lệ. Vui lòng kiểm tra lại!',
    ExpireOTP:
      'Mã xác thực đã hết hạn, vui lòng gửi lại tin nhắn để nhận mã OTP mới!',
    PasswordMismatch: 'Mật khẩu không chính xác',
    LimitTimeOTP:
      'Bạn đã nhập xác thực quá số lần cho phép, vui lòng soạn lại tin nhắn!',
    ResubmitGetOtp: 'Bạn chưa nhận được mã xác thực?',
    Resubmit: 'Gửi lại',
  },

  EnrollmentStudentProfile: {
    RegisterTitle: 'Tạo tài khoản quản lý hồ sơ',
    RegisterSubtitle:
      'Hồ sơ được quản lý theo tài khoản với tên đăng nhập là SĐT. Vui lòng bổ sung thông tin để dễ dàng thực hiện tra cứu và theo dõi kết quả tuyển sinh',
  },
}
